<template>
  <div v-bind:class="mapStyle">
    <ul>
      <li v-for="(page,index) in pageList" :key="'arrow_flow-' + index" :value="page.id"
          v-bind:style="{left: (-20 * index) + 'px'}"
          v-bind:class="{selected: (page.key == pageKey)}">
        <div class="pageTitle" @click="route(page.route, page.params)"><a>{{page.title}}</a></div>
        <div v-if="index !== (pageList.length - 1)" class="arrow">&gt;</div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'addNewUserModal',
  components: {
  },
  props: {
    pageKey: String,
    pageList: Array,
    mapStyle: {
      default: 'arrow_flow',
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {
    route: function (name, params) {
      if (!name) return
      this.$router.push({
        name: name,
        query: params
      })
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/DcSiteMap.vue